import CareersHero from 'components/shared/CareersHero'
import CareersPositions from 'components/shared/CareersPositions'
import Layout from 'components/shared/Layout'
import SliceManager from 'components/shared/SliceManager'
import CardsSlider from 'components/slices/CardsSlider'
import UniversalRichText from 'components/slices/UniversalRichText'
import PreviewBanner from 'components/shared/PreviewBanner'

import { fetchPositions, getDataDependencies } from 'services/api'

import fetchSingleType from 'src/lib/Strapi/fetchSingleType'

const Careers = ({ pageData, positions, preview }) => {
  const {
    careersHero,
    slices,
    careersPositions,
    alertForm,
    aboveReviews,
    reviews,
  } = pageData

  return (
    <>
      {preview && <PreviewBanner />}
      <CareersHero {...careersHero} />
      {slices && <SliceManager slices={slices} />}
      <CareersPositions
        intro={careersPositions}
        form={alertForm}
        positions={positions}
      />
      {aboveReviews && (
        <Layout type="wrapper">
          <UniversalRichText {...aboveReviews} />
        </Layout>
      )}
      {reviews && <CardsSlider type="reviews" items={reviews} />}
    </>
  )
}

export async function getServerSideProps({ query, preview = null }) {
  const data = await fetchSingleType('career', preview)

  const positions = await fetchPositions(query)

  const extendedData = await getDataDependencies(data)

  return {
    props: { pageData: extendedData, positions, preview },
  }
}

export default Careers
